// extracted by mini-css-extract-plugin
var _1 = "useProvisionEntitySearchConfig-module__icon--fw4pX";
export { _1 as "icon" }
